import { createContext } from 'react'
import type { ImportSelectionContextValue } from '../../types/importPreviousSeasons'
import {
  importSummary,
  initialImportSelection,
} from '../../utils/importSelection'

/**
 * The import dialog's ticks, typed addresses and row errors, read by the grid's
 * cells and its header box. A context rather than row data: typing must not
 * change a row, or AG Grid would redraw the cell and take the field's focus
 * with it.
 */
export const ImportSelectionContext =
  createContext<ImportSelectionContextValue>({
    state: initialImportSelection(null),
    dispatch: () => undefined,
    rows: [],
    summary: importSummary([], initialImportSelection(null), null),
    locked: false,
  })
